/** @jsxImportSource @emotion/react */
import React from 'react';
import tw from 'twin.macro';

export const SnippetFlexWrapper = tw.div`flex flex-col place-items-center place-content-center`;
export const SnippetContainerBox = tw.div`p-4 bg-white rounded`;
